import DailyActivityItem from './daily-activity-item-style'
export default DailyActivityItem
